<template>
  <div class="turntable">
    <template>
      <div class="tables">
        <el-button type="primary" @click="addActivity" size="small"
          >添加活动</el-button
        >
        <template>
          <el-table :data="tableData" style="width: 98%">
            <el-table-column
              prop="id"
              label="ID"
              min-width="140"
            ></el-table-column>
            <el-table-column
              prop="title"
              label="活动标题"
              min-width="140"
            ></el-table-column>
            <el-table-column
              prop="start_time"
              label="开始时间"
              min-width="140"
            ></el-table-column>
            <el-table-column
              prop="end_time"
              label="结束时间"
              min-width="140"
            ></el-table-column>
            <el-table-column
              prop="intro"
              label="活动说明"
              min-width="140"
            ></el-table-column>
            <el-table-column label="奖项预览(奖项*数量)" min-width="140">
              <template slot-scope="scope">
                <div class="awards">
                  <p v-for="(item, index) in scope.row.products" :key="index">
                    {{ item.item_name }}*{{ item.num }}
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="状态" min-width="140">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.is_default">开启</el-tag>
                <el-tag type="info" v-else>关闭</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="使用位置" min-width="140">
              <template slot-scope="scope">
                <span>{{ scope.row.method | turn_pos }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="200">
              <template slot-scope="scope">
                <el-button size="small" @click="editActivty(scope.row)"
                  >编辑</el-button
                >
                <el-button size="small" @click="deleteRow(scope.row)"
                  >删除</el-button
                >
                <el-button
                  size="small"
                  v-if="scope.row.is_default == 0"
                  @click="set_status(scope.row)"
                  type="success"
                  >启用</el-button
                >
                <el-button
                  size="small"
                  v-if="scope.row.is_default == 1"
                  @click="set_status(scope.row)"
                  type="danger"
                  >禁用</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </template>
    <el-pagination
      style="margin-top:15px;"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10]"
      :page-size="10"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total_num"
    ></el-pagination>
  </div>
</template>

<script>
import { bigwheelList, bigwheelDel } from "@/api/drawAward";
import { setTurnStatus } from "@/api/active";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  filters: {
    turn_pos: function(val) {
      switch (val) {
        case 0:
          return "会员中心";
        case 1:
          return "支付成功";
        case 2:
          return "不限";
        default:
          break;
      }
    }
  },
  data() {
    return {
      tableData: [],
      page: 0,
      total_num: 0,
      currentPage: 1
    };
  },
  mounted() {
    this.getList(1);
  },
  methods: {
    editActivty(val) {
      // 编辑资料
      this.$router.push({
        path: "addTurntable",
        query: {
          id: val.id
        }
      });
    },
    async set_status(item) {
      try {
        let data = {
          token: this.token,
          app_id: this.app_id,
          is_default: item.is_default == 1 ? 0 : 1,
          id: item.id
        };
        const res = await setTurnStatus(data);
        this.$message(res.msg);
        this.getList(1);
      } catch (error) {
        console.log(error);
      }
    },
    handleCurrentChange(val) {
      this.getList(val);
    },
    deleteRow(row) {
      this.$confirm("此操作将永久删除该活动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = {
            token: this.token,
            id: row.id,
            app_id: this.app_id
          };
          bigwheelDel(data).then(res => {
            this.page = 0;
            this.getList();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    getList(page) {
      // 列表数据
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: "",
        store_id: "",
        page: page
      };
      bigwheelList(data).then(res => {
        this.tableData = res.data.result;
        this.total_num = res.data.total_num;
      });
    },
    addActivity() {
      this.$router.push("addTurntable");
    }
  }
};
</script>

<style lang="scss" scoped>
.turntable {
  width: 100%;
  padding: 15px 25px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  .el-input {
    width: 60%;
  }
  .screen {
    display: flex;
    flex-direction: row;
    margin-bottom: 25px;
    .el-button,
    .el-select,
    .el-input {
      margin-right: 10px;
    }
  }
  .tables {
    width: 100%;
    .headline {
      height: 28px;
      line-height: 28px;
      border-bottom: 1px solid #999;
      font-size: 16px;
      margin-bottom: 15px;
    }

    .el-table {
      margin-top: 15px;

      .awards {
        height: 60px;
        overflow: auto;
      }
    }

    .marginbtm15 {
      margin-bottom: 15px;
    }
  }
}
</style>

<style lang="scss">
.turntable {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .has-gutter {
    th {
      background: #f0f2f5;
    }
  }
}
</style>
